module.exports = __webpack_public_path__ + "static/media/18a-06_ST-2018-1638x1334mm-oleo-sobre-tela.923ca0a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-06_ST-2018-1638x1334mm-oleo-sobre-tela.jpg
// module id = 224
// module chunks = 0